import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AgentRoutingModule } from './agent-routing.module';
import { AddEditAgentComponent } from './add-edit-agent/add-edit-agent.component';
import { AgentTableComponent } from './agent-table/agent-table.component';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzInputModule } from 'ng-zorro-antd/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { AddEditContactComponent } from './add-edit-agent/add-edit-contact/add-edit-contact.component';
import { SharedModule } from '../shared/shared.module';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import {LucideAngularModule} from "lucide-angular";
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
  declarations: [
    AddEditAgentComponent,
    AgentTableComponent,
    AddEditContactComponent,
  ],
  imports: [
    SharedModule,
    CommonModule,
    AgentRoutingModule,
    NzPageHeaderModule,
    NzSpaceModule,
    NzInputModule,
    FormsModule,
    NzButtonModule,
    NzTableModule,
    NzTagModule,
    NzAlertModule,
    NzFormModule,
    NzGridModule,
    NzSelectModule,
    ReactiveFormsModule,
    NzIconModule,
    NzToolTipModule,
    LucideAngularModule,
    TranslocoModule,
  ],
})
export class AgentModule {}
